import { Routes } from '@angular/router';
import { requireTableContextGuard } from './core/guards/table-context.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'demo', pathMatch: 'full' },
  {
    path: 'demo',
    loadComponent: () => import('./features/demo/table-select/table-select').then((m) => m.TableSelect)
  },
  {
    path: 'cart',
    loadComponent: () => import('./features/cart/cart-page/cart-page').then((m) => m.CartPage)
  },
  {
    path: 'checkout',
    loadComponent: () => import('./features/checkout/checkout-page/checkout-page').then((m) => m.CheckoutPage)
  },
  {
    path: 'order-confirmation/:orderId',
    loadComponent: () =>
      import('./features/order-confirmation/order-confirmation-page/order-confirmation-page').then(
        (m) => m.OrderConfirmationPage
      )
  },
  {
    path: ':storeId',
    canActivate: [requireTableContextGuard],
    loadComponent: () => import('./features/menu/menu-page/menu-page').then((m) => m.MenuPage)
  },
  { path: '**', redirectTo: 'demo' }
];
